import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './i18n';
import './styles/main.css';
import './styles/blog.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Avantages from './components/Avantages';
import Services from './components/Services';
import Processus from './components/Processus';
import PanneauxSolaires from './components/PanneauxSolaires';
import CoordinationChantiers from './components/CoordinationChantiers';
import Temoignages from './components/Temoignages';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Chatbot from './components/Chatbot';
import ChatWidget from './components/ChatWidget';
import Blog from './components/Blog';
import BlogPost from './components/BlogPost';

// Scroll vers l'ancre après navigation (robuste, attend le rendu)
const ScrollToHash = () => {
  const location = useLocation();
  React.useEffect(() => {
    if (typeof window === 'undefined') return;
    const hash = location.hash ? location.hash.replace('#', '') : '';
    if (!hash) return;

    const tryScroll = () => {
      const el = document.getElementById(hash);
      if (!el) return false;
      const y = el.getBoundingClientRect().top + window.scrollY - 90; // header offset
      window.scrollTo({ top: y, behavior: 'smooth' });
      return true;
    };

    // Réessaye quelques fois pour laisser le temps au DOM de se monter
    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (tryScroll() || attempts > 10) {
        clearInterval(timer);
      }
    }, 50);

    return () => clearInterval(timer);
  }, [location]);
  return null;
};

const HomePage = () => (
  <>
    <Hero />
    <Avantages />
    <Services />
    <Processus />
    <PanneauxSolaires />
    <CoordinationChantiers />
    <Temoignages />
    <FAQ />
    <Blog />
    <Contact />
  </>
);

function App() {
  return (
    <Router>
      <div className="App" id="app-root">
        <ScrollToHash />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
          </Routes>
        </main>
        <Chatbot />
        <ChatWidget />
      </div>
    </Router>
  );
}

export default App;
